//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectObjectList.js";
import "../GeometricUtilities/GeometricUtilities.CurveOptions.js";
import "../no/Section.js";
import "../no/SelectPoint.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CurveEndOption",1,0],[0,"CurveExtensionType",1,0],[1,"CurveList",0,"SelectObjectList",0],[1,"CurveOptions",0,"GeometricUtilities.CurveOptions",0],[0,"CurveTrimRegionOption",1,0],[1,"CurvesToTrim",0,"Section",0],[1,"FirstBoundingObject",0,"SelectObjectList",0],[0,"FirstBoundingObjectEndOption",1,0],[0,"FirstBoundingObjectOption",1,0],[0,"FirstBoundingObjectPickPoint",1,0],[0,"FirstBoundingPlane",1,"Plane",0],[1,"FirstReferenceIntersection",0,"SelectPoint",0],[0,"InteresectionDirectionOption",1,0],[0,"InteresectionMethod",1,0],[0,"InteresectionOptionVector",1,"Direction",0],[1,"ReverseTrimEnd",0,"SelectObjectList",0],[1,"SecondBoundingObject",0,"SelectObjectList",0],[0,"SecondBoundingObjectEndOption",1,0],[0,"SecondBoundingObjectOption",1,0],[0,"SecondBoundingObjectPickPoint",1,0],[0,"SecondBoundingPlane",1,"Plane",0],[1,"SecondReferenceIntersection",0,"SelectPoint",0],[0,"TrimBoundingObjects",1,0]],[],[]];
SPLM.Features.TrimCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TrimCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TrimCurveBuilder.CurveEndOptions = Object.freeze({
    "Start" : "Start", "End" : "End"});

SPLM.Features.TrimCurveBuilder.FirstBoundingObjectOptions = Object.freeze({
    "SelectObject" : "SelectObject", "SpecifyPlane" : "SpecifyPlane"});

SPLM.Features.TrimCurveBuilder.FirstBoundingObjectEndOptions = Object.freeze({
    "Start" : "Start", "End" : "End"});

SPLM.Features.TrimCurveBuilder.SecondBoundingObjectOptions = Object.freeze({
    "SelectObject" : "SelectObject", "SpecifyPlane" : "SpecifyPlane"});

SPLM.Features.TrimCurveBuilder.SecondBoundingObjectEndOptions = Object.freeze({
    "Start" : "Start", "End" : "End"});

SPLM.Features.TrimCurveBuilder.InteresectionDirectionOptions = Object.freeze({
    "Shortest3dDistance" : "Shortest3dDistance", "RelativeToWcs" : "RelativeToWcs", "AlongAVector" : "AlongAVector", "AlongScreenNormal" : "AlongScreenNormal"});

SPLM.Features.TrimCurveBuilder.InteresectionMethods = Object.freeze({
    "Inferred" : "Inferred", "UserDefined" : "UserDefined"});

SPLM.Features.TrimCurveBuilder.CurveExtensionTypes = Object.freeze({
    "Natural" : "Natural", "Linear" : "Linear", "Circular" : "Circular", "None" : "None"});

SPLM.Features.TrimCurveBuilder.CurveTrimRegionOptions = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

export default SPLM;